// extracted by mini-css-extract-plugin
export default {"form":"ContactInfo_form__R3RaF","subtitle":"ContactInfo_subtitle__XYVUu","top":"ContactInfo_top__S5XlD","item":"ContactInfo_item__s0dnN","tel":"ContactInfo_tel__-+sv8"};